
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/modal.vue";

@Options({
  components: {Modal},
  data(){
    return{
      img:"",
      tip:"",
    }
  },
  methods: {
  openModal(img:any,tip:string = ""){
    if (Array.isArray(img)){
      this.img = [...img]
    }else{
      this.img = [img]
    }
    this.tip = tip
    this.$refs.showImageModal.openModal()
  },
    closeModal(){
      this.$refs.showImageModal.closeModal()
    }
  }
})
export default class App extends Vue {
}
